import React, { useState } from 'react';
import { Button, Modal, Form, Message } from 'semantic-ui-react'

import TraineeRole from '../role_components/trainee_role';
import withDefaultRoleOptions from '../with_default_role_options';
import { validateTrainee, hasValue } from '../../../helpers';

import './index.css'

function TraineeModal (props) {
  const { selectedTrainee, defaultRoleOptions, updateTrainee, createTrainee, onClose } = props;
  const blankTrainee = {
    first_name: '',
    last_name: '',
    email: '',
    role_list: []
  }
  const defaultState = {
    trainee: (selectedTrainee || blankTrainee),
    errorFirstName: false,
    errorLastName: false,
    errorEmail: false,
    errorRoles: false,
    errorList: []
  }

  const [state, setState] = useState(defaultState);
  const { trainee, errorFirstName, errorLastName, errorEmail, errorList } = state;

  const isEditMode = selectedTrainee && selectedTrainee.id;

  const updateCurrentTrainee = (trainee) => {
    const errors = validateTrainee(trainee);
    const errorList= Object.values(errors).filter((e) => e);
    const { first_name, last_name, email, role_list } = errors;
    const newState = { 
      trainee,
      errorFirstName: hasValue(first_name),
      errorLastName: hasValue(last_name),
      errorEmail: hasValue(email),
      errorRoles: hasValue(role_list),
      errorList
    };

    setState(newState);

    return newState;
  }

  const onChangeFirstName = (value) => {
    let { trainee } = state;
    trainee.first_name = value;

    updateCurrentTrainee(trainee);
  }

  const onChangeLastName = (value) => {
    let { trainee  } = state;
    trainee.last_name = value;

    updateCurrentTrainee(trainee);
  }

  const onChangeEmail = (value) => {
    let { trainee  } = state;
    trainee.email = value;

    updateCurrentTrainee(trainee);
  }

  const onSave = () => {
    let { trainee } = state;

    const newState = updateCurrentTrainee(trainee);

    if (newState.errorList.length > 0) return;

    if(trainee.id) {
      trainee.fullname = `${trainee.last_name.toUpperCase()}, ${trainee.first_name}`
      updateTrainee(trainee)
    }
    else {
      createTrainee(trainee)
    }

    onClose()
  }

  const updateRoles = (value) => {
    let { trainee } = state;
    trainee.role_list = value;

    updateCurrentTrainee(trainee);
  }

  const createNewRole = (tag) => {
    if (!defaultRoleOptions.includes(tag)){
      defaultRoleOptions.unshift(tag)
    }
  }

  const removeRole = (evt, role) => {
    let { trainee } = state;
    const role_list = trainee.role_list.filter((item)=>{ return item !== role });
    trainee.role_list = role_list
    setState({...state, trainee})
  }

  return (
    <Modal size={ 'mini' } dimmer={ 'inverted' } open={ true } >
      <Modal.Header>{isEditMode ? "Edit Trainee" : "Add Trainee"}</Modal.Header>
      <Modal.Content className="trainee-modal-content">
        <Form className="custom-form">
          <Form.Input fluid label='First name' placeholder='First name' error={ errorFirstName } onChange={ (target, prop) => onChangeFirstName(prop.value) } value={trainee.first_name}/>
          <Form.Input fluid label='Last name' placeholder='Last name' error={ errorLastName } onChange={ (target, prop) => onChangeLastName(prop.value) } value={trainee.last_name}/>
          <Form.Input fluid label='Email' placeholder='Email' error={ errorEmail } onChange={ (target, prop) => onChangeEmail(prop.value) } value={trainee.email}/>
        </Form>
        <TraineeRole
          roleList={trainee.role_list || []}
          roleOptions={defaultRoleOptions}
          updateRoles={updateRoles}
          createNewRole={createNewRole}
          removeRole={removeRole}
        />
        { errorList.length > 0 && <Message className="custom-message" error header="The trainee requires the following values" list={errorList}/> }
      </Modal.Content>
      <Modal.Actions>
        <Button
          negative
          content="Cancel"
          onClick={ onClose }
        />
        <Button
          positive
          content={isEditMode ? "Update": "Add"}
          onClick={ onSave }
        />
      </Modal.Actions>
    </Modal>
  )
}

export default withDefaultRoleOptions(TraineeModal);



// WEBPACK FOOTER //
// ./src/views/components/modals/trainee_modal.js